import { Button, Menu, MenuItem } from "@mui/material";
import React, { useMemo, useState } from "react";
import { License } from "types/Licenses";
import { TransportDriver } from "types/TransportDriver";
import { Travel } from "types/Travel";
import { Vehicle } from "types/Vehicles";

type Props = {
  transportDriver: TransportDriver;
  handleOpenPersonalDataModal: (vehicles: Vehicle[], licenses: License[], lastLocation: any) => void;
  handleOpenTravelsModal: (travels: Travel[]) => void;
  handleVerifyClick: (transportDriverId: number) => void;
  handleConvertToDeliveryDriver: (transportDriverId: number) => void;
  handleOpenDepositModal: (transportDriver: { id: number; name: string; phone: string }) => void;
};

type MenuItemModel = {
  label: string;
  onClick: () => void;
};

const TransportDriverMenuItem: React.FC<Props> = ({
  transportDriver,
  handleOpenPersonalDataModal,
  handleOpenTravelsModal,
  handleConvertToDeliveryDriver,
  handleVerifyClick,
  handleOpenDepositModal,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const items = useMemo(() => {
    const itemModels: MenuItemModel[] = [
      {
        label: "Datos personales",
        onClick: () => {
          handleOpenPersonalDataModal(transportDriver.vehicles, transportDriver.license, transportDriver.lastLocation);
          setAnchorEl(null);
        },
      },
      {
        label: "Viajes realizados",
        onClick: () => {
          handleOpenTravelsModal(transportDriver.travels);
          setAnchorEl(null);
        },
      },
    ];
    if (transportDriver.isVerified === false) {
      itemModels.push({
        label: "Verificar",
        onClick: () => {
          handleVerifyClick(transportDriver.id);
          setAnchorEl(null);
        },
      });
    }
    if (transportDriver.user.driver === null) {
      itemModels.push({
        label: "Convertir a repartidor",
        onClick: () => {
          handleConvertToDeliveryDriver(transportDriver.id);
          setAnchorEl(null);
        },
      });
    }
    itemModels.push({
      label: "Deposito",
      onClick: () => {
        handleOpenDepositModal({
          id: transportDriver.id,
          name: transportDriver.user.name,
          phone: transportDriver.user.phone,
        });
        setAnchorEl(null);
      },
    });
    return itemModels;
  }, [transportDriver]);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        Detalles
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleCloseMenu}>
        {items.map(({ label, onClick }, i) => (
          <MenuItem key={i} onClick={onClick}>
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default TransportDriverMenuItem;
